import React from "react";
import { Modal, Box, Button } from "@material-ui/core";
import { ArrowForwardIos } from "@material-ui/icons";
import { styles, TypeButton, typeStyle } from "./styles";
import { IPromotionTypes } from "./promotionsTypes";
import { SectionWrapper } from "../section-wrapper";
import { format } from "lib/globalize-util";
import { DATATEST } from "constants/integration";

export const PromotionTypeModal: React.FC<IPromotionTypes> = ({ isModalOpen, promotionTypes, onToggle, onClick }) => {
    return (
        <Modal
            open={isModalOpen}
            onClose={() => onToggle()}
            data-test={DATATEST.PROMOTIONS.PROMOTION_TYPE_MODAL_WRAPPER}
        >
            <Box css={styles.boxStyle}>
                <div style={styles.contentStyle}>
                    <div style={{ padding: "20px 24px" }}>
                        <h2 style={{ fontWeight: "bold", width: "60%", color: "black" }}>{format("Promotion type")}</h2>
                    </div>
                    <div>
                        {promotionTypes.map((promo, index) => (
                            <div style={typeStyle(index)} key={index}>
                                <TypeButton
                                    onClick={() => onClick(promo.value)}
                                    data-test={DATATEST.PROMOTIONS.PROMOTION_TYPE_MODAL_ITEM}
                                >
                                    <div style={styles.typeStyle}>
                                        <SectionWrapper
                                            title={promo.name}
                                            subtitle={promo.description}
                                            labelStyle={{ margin: "0", padding: "0" }}
                                        />
                                        <ArrowForwardIos />
                                    </div>
                                </TypeButton>
                            </div>
                        ))}
                    </div>
                    <div style={styles.cancelWrapperStyle}>
                        <Button style={styles.cancelButtonStyle} variant="outlined" onClick={() => onToggle()}>
                            {format("Cancel")}
                        </Button>
                    </div>
                </div>
            </Box>
        </Modal>
    );
};
